import React from 'react';

/** Zoom-style "Leave meeting?" confirmation, styled to match the dark glass
 * call overlay rather than the app's regular light modals. */
export default function ConfirmEndCallModal({ isOpen, onCancel, onConfirm }) {
  if (!isOpen) return null;

  return (
    <div
      style={{
        position: 'fixed', inset: 0, zIndex: 2147483647,
        background: 'rgba(0,0,0,0.35)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}
      onClick={onCancel}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: 'rgba(28,28,30,0.96)', backdropFilter: 'blur(16px)',
          borderRadius: 14, padding: '22px 24px', minWidth: 260, maxWidth: 320,
          boxShadow: '0 16px 40px rgba(0,0,0,0.5)', textAlign: 'center',
        }}
      >
        <h3 style={{ margin: '0 0 8px', fontSize: 16, fontWeight: 600, color: '#fff' }}>
          End call?
        </h3>
        <p style={{ margin: '0 0 20px', fontSize: 13, color: 'rgba(255,255,255,0.65)', lineHeight: 1.5 }}>
          This will end the call for you and the other participant.
        </p>
        <div style={{ display: 'flex', gap: 10, justifyContent: 'center' }}>
          <button
            onClick={onCancel}
            style={{
              flex: 1, padding: '9px 0', fontSize: 13, fontWeight: 600,
              background: 'rgba(255,255,255,0.12)', color: '#fff',
              border: 'none', borderRadius: 8, cursor: 'pointer',
            }}
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            style={{
              flex: 1, padding: '9px 0', fontSize: 13, fontWeight: 600,
              background: '#ef4444', color: '#fff',
              border: 'none', borderRadius: 8, cursor: 'pointer',
            }}
          >
            End call
          </button>
        </div>
      </div>
    </div>
  );
}
